import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Home.scss";

export default class Home extends Component {
  render() {
    return (
      <div className="App">
        <br />
        <div className="image">
          <Link to="/empty-spaces">
            {/* <a href="https://twitter.com/telephonesound/status/1456298539303194627"> */}
            <div className="ts-el">
              <span className="t">T</span>
              <span className="s">elephone Sound</span>
            </div>
            <br />
            {/* </a> */}
            <div className="el">…</div>
          </Link>
        </div>
        <br /> <br />
        <br /> <br />
        <br /> <br />
        <div className="main">
          <div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <a
              href="https://tinyurl.com/fern-the-willow-tree-video"
              target="_blank"
              rel="noopener noreferrer"
            >
              <iframe
                title="The Willow Tree (English) - Fern Vale - Music Video (YouTube)"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/mKJCu6OkUu8"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </a>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>

          {/* <div style={{maxWidth: '820px', marginLeft: 'auto', marginRight: 'auto'}}> */}
          <div>
            {/* <a href="https://archive.org/search.php?query=description%3A%28%23djf%29%20AND%20mediatype%3A%28audio%29" target="_blank" rel="noopener noreferrer"> */}
            <br />
            <br />
            <br />

            {/* <p style={{ 'color': '#FFFFFF', }}>#djf #mix</p>

					<iframe title="djf_T2021_10_25_Z03_00_EST" width="100%" height="120" src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&autoplay=0&feed=%2FDefcronyke%2Fdjf_t2021_10_25_z03_00_est%2F" frameBorder="0" allow="autoplay" /> */}

            {/* <iframe title="djf_T2021_10_25_Z03_00_EST" width="100%" height="120" src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&autoplay=1&feed=%2FDefcronyke%2Fdjf_t2021_10_25_z03_00_est%2F" frameBorder="0" allow="autoplay" /> */}

            <br />
            <br />
            {/* </a> */}
          </div>

          <div>
            <br />
            <br />

            {/* <a href="https://touanda.com" target="_blank" rel="noopener noreferrer">
					<p style={{ 'color': '#FFFFFF', }}>defcron hifi mix of "bullet" radio by touanda and craig johnstone</p>
					<br />
					<iframe title="defcron hifi mix of bullet radio by touanda and craig johnstone" src="https://archive.org/embed/bullet-craig-johnstone-and-touanda-defcron-cover-02" width="500" height="140" frameBorder="0" webkitAllowFullScreen="true" mozAllowFullScreen="true" allowFullScreen />
				</a> */}
          </div>

          {/* <div>
				<a href="https://archive.org/embed/bells-in-santa-fe-iichliwp-h4-halsey-djf-mix" target="_blank" rel="noopener noreferrer">
					<div>
						<a href="https://archive.org/embed/bells-in-santa-fe-halsey-djf-mix-audio" target="_blank" rel="noopener noreferrer">
							<div>
								<br />
								<iframe title="bells_in_santa_fe <- @halsey := [djf_mix] (audio_only, version) { 0; }" src="https://audius.co/embed/track/V04KQ?flavor=compact" width="100%" height="120" allow="encrypted-media; autoplay" style={{border: "none;"}} />
								<br />
								<br />
							</div>
						</a>
					</div>
				</a>

				<a href="https://www.instagram.com/tv/CVcCOJLFkFg/?utm_source=ig_web_copy_link" target="_blank" rel="noopener noreferrer">
					<br />
					<div>
						<br />

						<a href="https://fb.watch/8SflB-Gbqw?t=102" target="_blank" rel="noopener noreferrer">
							<br />
						
							<div>

								<iframe title="bells_in_santa_fe <- @halsey := [djf_mix](youtube, video) { 0; }" width="560" height="315" src="https://www.youtube-nocookie.com/embed/CdQ5YigPIhQ?start=97" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
								<br />
								<br />

							</div>

							<br />
						</a>

					</div>
				
					<br />
					<br />

					</a>

				<br />
			</div> */}

          {/* <iframe alt="http://chonkify.me" title="minigame (for kids)" src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ftelephonesound%2Fposts%2F1432669717138880&show_text=true&width=500" width="500" height="543" scrolling="no" frameBorder="0" allowFullScreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" /> */}

          {/* <div>
				<a href="https://archive.org/embed/2021-10-10_202110" target="_blank" rel="noopener noreferrer" style={{padding: '2em'}}>

					<br /> <br />

					<div>
						<a href="https://defcronyke.github.io/stacktris" target="_blank" rel="noopener noreferrer" style={{padding: '2em'}}>
							
							<br /> <br />
							
							<div>
								<iframe alt="https://defcronyke.github.io/stacktris" title="a web game that's a bit like tetris, but opposite" width="100%" height="120" src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&autoplay=0&feed=%2Fdjforg%2F2021-10-10-epoch%2F" frameBorder="0" allow="autoplay" />
							</div>

							<br /> <br />

							<div>
	
								<br /> <br />

								<a href="https://archive.org/embed/bullet-craig-johnstone-and-touanda-djf-mix" target="_blank" rel="noopener noreferrer">

									<br /> <br />
	
									<iframe title="telephone sound likes these songs by other artists (audius.co embedded player)" src="https://audius.co/embed/playlist/DrA9Q?flavor=card" width="100%" height="480" allow="encrypted-media" style={{'border': 'none;'}} />

									<br /> <br />
								</a>
							</div>

							<br /> <br />
						</a>
					</div>

					<br /> <br />

				</a>
			</div> */}

          {/* <br />      <br />
			<br />      <br />  <br /><br /><br />
			<br />      <br />              <br />
			<br /><br /><br />				
			<br />      <br />
			<br />      <br /> */}

          {/* <div>
				<a href ="https://tinyurl.com/ts-blankets" target="_blank" rel="noopener noreferrer">

					<br />

					<p style={{ 'color': '#FFFFFF', }}>blanket - ts blankets</p>

					<iframe title="blanket - ts blankets - (YouTube cover album)" width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PL49dWPZn7_EykcJaANV3EUAwA64Eb58yk" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
					
					<br /> <br />
					<br />
				</a>
			</div> */}

          {/* <div>
				<a href="https://www.youtube.com/channel/UCIsZQlxaFXUGlpCFRLJAfbQ" target="_blank" rel="noopener noreferrer">
					<br /> <br />
					
					<p style={{ 'color': '#FFFFFF', }}>ts blankets YouTube likes</p>
					
					<iframe title="ts blankets loves other artists playlist (YouTube embedded player)" width="560" height="315" src="https://www.youtube-nocookie.com/embed/videoseries?list=PL49dWPZn7_ExP001PG1amPPo-XYOGAALr" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />

					<br /> <br />
					<br />
				</a>
			</div> */}

          {/* <br />      <br />
			<br />      <br />  <br />      <br />
			<br />      <br />  <br /><br /><br />
			<br />      <br />              <br />
			<br />      <br />              <br />
			<br /><br /><br />				
			<br />      <br />
			<br />      <br />
			<br />      <br />
			<br />      <br /> */}

          <div>
            <Link to="/ellipsis-remastered-deluxe">
              <img
                src="./images/ellipsis-remastered-deluxe-album_cover.png"
                alt="The cover art of the 2020 remastered version of the debut album Ellipsis by Telephone Sound, which links to The official web page for the album."
              />
            </Link>
          </div>
          <div>
            <Link to="/empty-spaces">
              <img
                src="./images/empty_spaces-album_cover.png"
                alt="The cover art of the second album Empty Spaces by Telephone Sound, which links to The official web page for the album."
              />
            </Link>
          </div>
          <div>
            <Link to="/ellipsis">
              <img
                src="./images/ellipsis-album_cover.png"
                alt="The cover art of the debut album Ellipsis by Telephone Sound, which links to The official web page for the album."
              />
            </Link>
          </div>
          {/* <iframe title="Telephone Sound songs recommended by Telephone Sound, embedded from Audius." src="https://audius.co/embed/playlist?id=46925&ownerId=167306&flavor=card" width="100%" height="480" allow="encrypted-media" style={{'border': 'none'}} /> */}
          <br />
          <p
            style={{ fontSize: "10pt", textAlign: "left", marginLeft: "30px" }}
          >
            <a href="privacy-policy.html" style={{ color: "white" }}>
              View Privacy Policy
            </a>
          </p>
          <br />
        </div>
      </div>
    );
  }
}
